class DecimalImpl {
  public sum(a: number, b: number, fraction = 2): number {
    return this.round(a + b, fraction);
  }

  public diff(a: number, b: number, fraction = 2): number {
    return this.round(a - b, fraction);
  }

  public multiply(a: number, b: number, fraction = 2): number {
    return this.round(a * b, fraction);
  }

  public divide(a: number, b: number, fraction = 2): number {
    if (b === 0) {
      throw new Error("Division by zero");
    }
    return this.round(a / b, fraction);
  }

  public round(value: number, fraction: number = 2): number {
    const factor = Math.pow(10, fraction);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  }
}

export const Decimal = new DecimalImpl();
